import gatewayService from '@/modules/common/services/gatewayService';

const baseRoute = '/v3/payments/business_policy_settings';

/**
 * Save business policy settings for invoice numbering
 * @param {Object} payload - Business policy settings
 * @param {number} [payload.starting_invoice_number] - Starting invoice number (1-9999999)
 * @param {string} [payload.numbering_type] - Numbering type ('continuous' | 'reset_yearly')
 * @param {boolean} [payload.use_prefix] - Whether to use prefix (INV-/CN-)
 * @returns {Promise<Object>} Response data
 */
const saveBusinessPolicySettings = async (payload) => {
  try {
    const response = await gatewayService.post(baseRoute, payload);
    return response.data?.data;
  } catch (error) {
    console.error('Error saving business policy settings:', error);
    throw error;
  }
};

export default {
  saveBusinessPolicySettings,
};
